import { Network, Zap, Speaker, Cable, Building2, Factory, Settings, Shield, Camera, Flame, Wind } from 'lucide-react';
import { Service } from '../types';

export const services: Service[] = [
  {
    id: 'reseau',
    title: 'Réseau informatique',
    description: 'Installation et maintenance de réseaux informatiques professionnels',
    icon: Network
  },
  {
    id: 'electricite',
    title: 'Électricité',
    description: 'Services électriques complets pour entreprises et industries',
    icon: Zap
  },
  {
    id: 'sonorisation',
    title: 'Sonorisation',
    description: 'Solutions audio professionnelles et systèmes de sonorisation',
    icon: Speaker
  },
  {
    id: 'fibre',
    title: 'Fibre optique',
    description: 'Installation et maintenance de réseaux fibre optique',
    icon: Cable
  },
  {
    id: 'batiments',
    title: 'Électricité des bâtiments',
    description: 'Solutions électriques pour bâtiments tertiaires et industriels',
    icon: Building2
  },
  {
    id: 'transformation',
    title: 'Postes de transformation',
    description: 'Installation et maintenance de postes MT/BT et groupes électrogènes',
    icon: Factory
  },
  {
    id: 'gtc',
    title: 'GTC et GTB',
    description: 'Gestion technique et énergétique des bâtiments',
    icon: Settings
  },
  {
    id: 'precablage',
    title: 'Précâblage',
    description: 'Solutions de précâblage informatique et téléphonique',
    icon: Cable
  },
  {
    id: 'controle',
    title: 'Contrôle d\'accès',
    description: 'Systèmes de contrôle d\'accès et anti-intrusion',
    icon: Shield
  },
  {
    id: 'video',
    title: 'Vidéosurveillance',
    description: 'Solutions complètes de vidéosurveillance',
    icon: Camera
  },
  {
    id: 'incendie',
    title: 'Détection incendie',
    description: 'Systèmes de détection et d\'extinction automatique',
    icon: Flame
  },
  {
    id: 'climatisation',
    title: 'Climatisation',
    description: 'Solutions de climatisation professionnelles',
    icon: Wind
  }
];